import React from 'react'
import Typography from '../../../components/Basics/Typography';
import { Stack, ContainedListItem } from '@carbon/react'
import { Timer } from '@carbon/icons-react'
import { ListItemContainer, Separator, GridContainer, GridItem, CardItemContainer, OuterContainer } from './KpiTree.styles';
import { teal80, teal40, teal20, teal30 } from '@carbon/colors';


const AljibeTree = ({ marginBottom, wordPadding }) => {
	return (
    <Stack gap={4}>
      <GridContainer>
        <GridItem>
          <ContainedListItem>
            <CardItemContainer>
              <Typography className='cds--type-heading-compact-02' $margin={marginBottom}>Árbol de Aljibes</Typography>
            </CardItemContainer>
            <CardItemContainer>
              <Typography className='cds--type-body-02'>Producción</Typography>
              <Typography className='cds--type-heading-04' $margin={marginBottom}>6100 hr/día</Typography>
            </CardItemContainer>
          </ContainedListItem>
          <ContainedListItem />
        </GridItem>
        <GridItem borderTopColor={teal80}>
          <ContainedListItem>
            <CardItemContainer>
              <Typography className='cds--type-heading-compact-02' $margin='0 0 20px'>Disponibilidad mecánica</Typography>
            </CardItemContainer>
            <CardItemContainer>
              <Typography className='cds--type-body-01'>Promedio</Typography>
              <Typography className='cds--type-heading-04' $margin={marginBottom}>6 %</Typography>
            </CardItemContainer>
          </ContainedListItem>
          <ContainedListItem />
        </GridItem>
        <GridItem borderTopColor={teal80}>
          <ContainedListItem>
            <ListItemContainer>
              <Typography className='cds--type-body-01'></Typography>
              <Typography className='cds--type-body-01'>Promedio</Typography>
            </ListItemContainer>
          </ContainedListItem>
          <Separator />
          <OuterContainer>
            <ContainedListItem renderIcon={Timer}>
              <ListItemContainer>
                <Typography className='cds--type-body-01'>Tiempo en Mantenimiento</Typography>
                <Typography className='cds--type-body-01'>7 h</Typography>
              </ListItemContainer>
            </ContainedListItem>
          </OuterContainer>
          <Separator />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem isVisible={false} />
        <GridItem borderTopColor={teal40}>
          <ContainedListItem>
            <CardItemContainer>
              <Typography className='cds--type-heading-compact-02' $margin='0 0 20px'>Uso Operativo</Typography>
            </CardItemContainer>
            <CardItemContainer>
              <Typography className='cds--type-body-01'>Promedio</Typography>
              <Typography className='cds--type-heading-04' $margin={marginBottom}>65 %</Typography>
            </CardItemContainer>
          </ContainedListItem>
          <ContainedListItem />
        </GridItem>
        <GridItem borderTopColor={teal40}>
          <ContainedListItem>
            <ListItemContainer>
              <Typography className='cds--type-body-01'></Typography>
              <Typography className='cds--type-body-01' $margin={marginBottom}>Promedio</Typography>
            </ListItemContainer>
          </ContainedListItem>
          <Separator />
          <OuterContainer>
            <ContainedListItem renderIcon={Timer}>
              <ListItemContainer>
                <Typography className='cds--type-body-01'>Reservas Programadas</Typography>
                <Typography className='cds--type-body-01' $margin={marginBottom}>10,6 h</Typography>
              </ListItemContainer>
              <Separator $margin={marginBottom} />
              <ListItemContainer>
                <Typography className='cds--type-body-01' $padding={wordPadding}>Colación</Typography>
                <Typography className='cds--type-body-01' $margin={marginBottom}>1 h</Typography>
              </ListItemContainer>
              <Separator $margin={marginBottom} />
              <ListItemContainer>
                <Typography className='cds--type-body-01' $padding={wordPadding}>Cambio de turno</Typography>
                <Typography className='cds--type-body-01' $margin={marginBottom}>0,5 h</Typography>
              </ListItemContainer>
              <Separator $margin={marginBottom} />
              <ListItemContainer>
                <Typography className='cds--type-body-01' $padding={wordPadding}>Cargas combustible</Typography>
                <Typography className='cds--type-body-01' $margin={marginBottom}>0,4 h</Typography>
              </ListItemContainer>
              <Separator/>
            </ContainedListItem>
          </OuterContainer>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem isVisible={false} />
        <GridItem borderTopColor={teal20}>
          <ContainedListItem>
            <CardItemContainer>
              <Typography className='cds--type-body-02' $margin={marginBottom}>Rendimiento Operativo</Typography>
            </CardItemContainer>
            <CardItemContainer>
              <Typography className='cds--type-body-01'>Promedio</Typography>
              <Typography className='cds--type-heading-04' $margin={marginBottom}>8 hr/día</Typography>
            </CardItemContainer>
          </ContainedListItem>
          <ContainedListItem />
        </GridItem>
        <GridItem borderTopColor={teal20}>
          <ContainedListItem>
            <ListItemContainer>
              <Typography className='cds--type-body-01'></Typography>
              <Typography className='cds--type-body-01' $margin={marginBottom}>Promedio</Typography>
            </ListItemContainer>
          </ContainedListItem>
          <Separator />
          <OuterContainer>
            <ContainedListItem renderIcon={Timer}>
              <ListItemContainer>
                <Typography className='cds--type-body-01'>Pérdidas operacionales</Typography>
                <Typography className='cds--type-body-01' $margin={marginBottom}>0,3 h</Typography>
              </ListItemContainer>
              <Separator $margin={marginBottom} />
              <ListItemContainer>
                <Typography className='cds--type-body-01' $padding={wordPadding}>Tiempo en ralentí</Typography>
                <Typography className='cds--type-body-01' $margin={marginBottom}>2 hr/día</Typography>
              </ListItemContainer>
              <Separator $margin={marginBottom} />
              <ListItemContainer>
                <Typography className='cds--type-body-01' padding={wordPadding}>Cambio de postura</Typography>
                <Typography className='cds--type-body-01' $margin={marginBottom}>1 hr/día</Typography>
              </ListItemContainer>
              <Separator/>
            </ContainedListItem>
          </OuterContainer>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem isVisible={false} />
        <GridItem isVisible={false} />
        <GridItem borderTopColor={teal20}>
          <ContainedListItem>
            <ListItemContainer>
              <Typography className='cds--type-body-01'></Typography>
              <Typography className='cds--type-body-01' $margin={marginBottom}>Promedio</Typography>
            </ListItemContainer>
          </ContainedListItem>
          <Separator />
          <OuterContainer>
            <ContainedListItem renderIcon={Timer}>
              <ListItemContainer>
                <Typography className='cds--type-body-01'>Duración de trabajos</Typography>
                <Typography className='cds--type-body-01' $margin={marginBottom}>25,5 min</Typography>
              </ListItemContainer>
              <Separator $margin={marginBottom} />
              <ListItemContainer>
                <Typography className='cds--type-body-01' $padding={wordPadding}>Tiempo de traslado</Typography>
                <Typography className='cds--type-body-01' $margin={marginBottom}>25,5 min</Typography>
              </ListItemContainer>
              <Separator />
            </ContainedListItem>
          </OuterContainer>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem isVisible={false} />
        <GridItem borderTopColor={teal30}>
          <ContainedListItem>
            <CardItemContainer>
              <Typography className='cds--type-body-02' $margin={marginBottom}>Cantidad de Aljibes</Typography>
            </CardItemContainer>
            <CardItemContainer>
              <Typography className='cds--type-body-01'></Typography>
              <Typography className='cds--type-heading-04' $margin={marginBottom}>22 unidades</Typography>
            </CardItemContainer>
          </ContainedListItem>
          <ContainedListItem />
        </GridItem>
      </GridContainer>
    </Stack>
	)
}

export default AljibeTree